import _extends from "@babel/runtime/helpers/extends";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from "react";
import { useBlocker } from "../../contexts";
import { BlockerButtonsInlineStyles } from ".";

var BlockerButton = function BlockerButton(_ref) {
  var inlineStyle = _ref.inlineStyle,
      type = _ref.type,
      onClick = _ref.onClick,
      children = _ref.children,
      framed = _ref.framed;

  if (type === "hide") {
    return null;
  }

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHover = _useState2[0],
      setIsHover = _useState2[1];

  var banner = useBlocker();
  var interactionAttr = {
    onClick: onClick,
    onMouseEnter: function onMouseEnter() {
      return setIsHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHover(false);
    }
  };
  return h("div", _extends({}, type === "button" ? interactionAttr : {}, BlockerButtonsInlineStyles[inlineStyle](banner, isHover, framed)), h("span", type === "link" ? _objectSpread(_objectSpread({}, interactionAttr), {}, {
    style: {
      cursor: "pointer"
    }
  }) : {}, children));
};

export { BlockerButton };